import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setControllerChartPopUp } from 'stores/sensor/controllersSlice';
import { ControllerChartFields } from 'types/ControllerFields';
import FormattedChart from './components/FormattedChart';

export const getControllerChartDataset = (measurements, measurmentName) => {
  return {
    data: measurements,
    label: ControllerChartFields[measurmentName].display_value || 'N/A',
  };
};

const Charts = ({ onChartRangeSelect, chartRangeButtons, compact = false }) => {
  const measurementsData = useSelector(
    state => state.controllers.data.rangeMeasurements,
  );
//   // console.log('measurementsData:', measurementsData);

  const controllerId = useParams().id;
  // console.log('Charts controllerId:', controllerId);

  return (
    <>
      {/* prettier-ignore */}
      <FormattedChart
          title={controllerId}
          datasets={Object.keys(measurementsData).map(name => 
            getControllerChartDataset(measurementsData[name], name)
          )}
          isRange={false}
          setChartPopUp={setControllerChartPopUp}
          controllerId={controllerId}
          onChartRangeSelect={onChartRangeSelect}
          chartRangeButtons={chartRangeButtons}
          compact={compact}
        />
    </>
  );
};

export default Charts;
